import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

import { usePageHeader } from "@/shared/store/page-header";
import { OntologyExplorer } from "@/widgets/ontology/OntologyExplorer";

export const Route = createFileRoute("/_authenticated/ontology")({
  component: OntologyPage,
});

function OntologyPage() {
  const { setTitle, reset } = usePageHeader();

  useEffect(() => {
    setTitle("Ontology");
    return () => reset();
  }, [setTitle, reset]);

  return (
    <div className="h-full flex flex-col overflow-hidden">
      <OntologyExplorer />
    </div>
  );
}
